import { render } from "./ScheduledDelivery.vue?vue&type=template&id=511deb12&scoped=true"
import script from "./ScheduledDelivery.vue?vue&type=script&lang=js"
export * from "./ScheduledDelivery.vue?vue&type=script&lang=js"

import "./ScheduledDelivery.vue?vue&type=style&index=0&id=511deb12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511deb12"]])

export default __exports__